import React, { useContext, useCallback } from 'react';
import { ICategoryContext, CategoryContext } from '../categoryState/categoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<ICategoryContext>(CategoryContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteCategory"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteCategorySuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingCategory"
			/>
		</ModalWrapper>
	);
};
